export default ({ request }) => ({
  /**
  * 根据机构id获取appId
  * @param data
  * @returns {*}
  * @constructor
  */
  WECHAT_APP_ID(params = {}) {
    // 接口请求
    return request({
      url: '/organ',
      method: 'GET',
      params,
      timeout: 20000
    })
  },
  /**
   * 获取微信openid和userid
   * @param data
   * @returns {*}
   * @constructor
   */
  WECHAT_OPENID(params = {}) {
    // 接口请求
    return request({
      url: '/openid',
      method: 'GET',
      params,
      timeout: 20000
    })
  },
  /**
   * 微信签名接口（获取js-signature）
   * @param data
   * @returns {*}
   * @constructor
   */
  SYS_SHARE_INFO(params = {}) {
    // 接口请求
    return request({
      url: '/sign/url',
      method: 'GET',
      params
    })
  }
})

